export default "__VITE_ASSET__D$N0KP7i__"